/* Product gallery fix (2026-10-31):
   1) the active slide is found by real slide positions (the old math divided by the track width and drifted with gaps, so far slides like #20 got the wrong thumb),
   2) while a thumb click is scrolling the big image, the scroll listener is paused so it can't pick in-between slides,
   3) the thumb strip slides smoothly to centre the active thumb instead of jumping. */
(function(){
  if(!window.customElements)return;
  var reduce=function(){return window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;};
  function off(g,k){return g.slides[k].offsetLeft-g.slides[0].offsetLeft;}
  customElements.whenDefined('product-gallery').then(function(){
    var P=customElements.get('product-gallery').prototype;
    P.go=function(i,smooth){
      if(!this.slides||!this.slides.length)return;
      if(smooth===undefined)smooth=true;
      var n=(i+this.slides.length)%this.slides.length,self=this,sm=smooth&&!reduce();
      this._lock=true;clearTimeout(this._lt);
      var un=function(){self._lock=false;};
      this.track.addEventListener('scrollend',un,{once:true});
      this._lt=setTimeout(un,sm?1000:80);
      this.track.scrollTo({left:off(this,n),behavior:sm?'smooth':'auto'});
      this.update(n,sm);
    };
    P.sync=function(){
      if(this._lock||!this.slides||!this.slides.length)return;
      var sl=this.track.scrollLeft,best=0,bd=Infinity;
      for(var k=0;k<this.slides.length;k++){var d=Math.abs(off(this,k)-sl);if(d<bd){bd=d;best=k;}}
      if(best!==this.index)this.update(best,true);
    };
    P.update=function(i,smooth){
      this.index=i;
      this.slides.forEach(function(s,k){var on=k===i;s.toggleAttribute('aria-hidden',!on);var z=s.querySelector('[data-zoom]');if(z)z.tabIndex=on?0:-1;});
      this.thumbs.forEach(function(t,k){if(k===i)t.setAttribute('aria-current','true');else t.removeAttribute('aria-current');});
      var a=this.thumbs[i],list=a&&a.closest('[data-gallery-thumbs]');
      if(list&&list.scrollWidth>list.clientWidth){
        var ar=a.getBoundingClientRect(),lr=list.getBoundingClientRect(),left=list.scrollLeft+(ar.left+ar.width/2)-(lr.left+lr.width/2);
        list.scrollTo({left:left,behavior:(smooth&&!reduce())?'smooth':'auto'});
      }
      var total=this.slides.length;
      if(this.current)this.current.textContent=String(i+1);
      if(this.live)this.live.textContent=(i+1)+' / '+total;
    };
    document.querySelectorAll('product-gallery').forEach(function(g){
      if(g.track&&!g._fixed){g._fixed=1;g.track.addEventListener('scrollend',function(){g._lock=false;g.sync();});}
    });
  });
})();
